import React, {useState, useEffect} from "react"
import {toaster} from '../../../config'
import {logActivity} from '../../../services/utilService'
import {getMDHProjects, saveMDHData, getMDHData} from "../../../services/formService"
import CustomLoader from "../../common/Loader"
import Select from "react-select"
import * as Icon from "react-feather"
import CustomTooltip from '../../common/CustomTooltip'
import { stripTags } from '../../common/commonFuncs'

const WMDHData = ({Widget_ID, Form_ID, Project_ID, onRemove, Form_Widgets}) => {
    const [loading, setLoading] = useState(true)
    const [withinRow, setWithinRow] = useState(false)
    const [MDHProject, setMDHProject] = useState({label: "Select MDH Project...", value: 0})
    const [MDHProjects, setMDHProjects] = useState([])
    const [MDHSurvey, setMDHSurvey] = useState('') // need survey name, not survey display name
    const [questionStepIdentifier, setQuestionStepIdentifier] = useState('')
    const [title, setTitle] = useState('')
    const [widgetDescription, setWidgetDescription] = useState('')
    const [updateQuestion, setUpdateQuestion] = useState(false)
    const [updateQuestionWidgetID, setUpdateQuestionWidgetID] = useState()
    const [formQAQWidgets, setformQAWidgets] = useState(Form_Widgets.filter((w) => w.Widget_Type_ID === 2))
    const [type, setType] = useState('Get Participant Info');
    const [participantInfoFields, setParticipantInfoFields] = useState(['']);

    useEffect(() => {
        const preloadMDHData = async () => {
            // load MDH projects
            const projects = await getMDHProjects()
            let parsed_projects = [{label: "Select MDH Project...", value: 0}]
            projects.data.data.forEach(proj => {
                parsed_projects.push({
                    value: proj.id,
                    label: proj.name
                })
            })
            setMDHProjects(parsed_projects)

            const { data } = await getMDHData(Widget_ID);
            if (data.length !== 0) {
                setWithinRow(data[0].WithinRow)
                setMDHProject(data[0].MDH_Project_ID ? {
                    value: data[0].MDH_Project_ID,
                    label: parsed_projects.filter(proj => proj.value === data[0].MDH_Project_ID)[0].label
                } : { label: "Select MDH Project...", value: 0 })
                setType(data[0].Type)
                setParticipantInfoFields(data[0].Participant_Info_Field ? data[0].Participant_Info_Field.split(',') : [''])
                setMDHSurvey(data[0].MDH_Survey_Name || '')
                setQuestionStepIdentifier(data[0].MDH_Question_Step_Identifier || '')
                setTitle(data[0].Title || '')
                setWidgetDescription(data[0].Description || '')
                setUpdateQuestion(data[0].Update_Question_Widget_ID && data[0].Update_Question_Widget_ID > 0)
                setUpdateQuestionWidgetID(data[0].Update_Question_Widget_ID || 0)
            }
        }
        preloadMDHData()
            .then(() => setLoading(false))
        // eslint-disable-next-line
    }, [])

    const onSave = async () => {
        let fields = participantInfoFields.filter(f => f.trim() !== '').join(',');
        const { data } = await saveMDHData(Widget_ID, title, widgetDescription, MDHProject.value,
            type, fields, MDHSurvey, questionStepIdentifier, withinRow, updateQuestion ? updateQuestionWidgetID : null)
        if (data.includes("Error")) {
            toaster('error', data)
            logActivity('/formBuilder', 'WIDGET_MDH_SAVE_FAILED')
        } else {
            toaster('success', 'Widget saved.')
            logActivity('/formBuilder', 'WIDGET_MDH_SAVE_SUCCESS')
        }
    }

    const handleSwitch = ({target}) => {
        if (target.name === 'Include In Row') {
            setWithinRow(!withinRow)
        }
    }

    const handleSelectMDHProject = (selectedProject) => {
        setMDHProject(selectedProject)
    }

    const reset = () => {
        setParticipantInfoFields(['']);
        setUpdateQuestion(false);
        setMDHSurvey('');
        setQuestionStepIdentifier('');
    }

    const handleInput = ({target}) => {
        if (target.name === 'type') {
            setType(target.value);
            reset();
        } else if (target.name === 'title') {
            setTitle(target.value)
        } else if (target.name === 'widgetDescription') {
            setWidgetDescription(target.value)
        } else if (target.name === 'mdhSurvey') {
            setMDHSurvey(target.value)
        } else if (target.name === 'questionStepIdentifier') {
            setQuestionStepIdentifier(target.value)
        }
    }

    const handleUpdateQuestionChange = () => {
        setUpdateQuestion(!updateQuestion)
    }

    const handleUpdateQuestionWidgetIDSelection = (value) => {
        setUpdateQuestionWidgetID(value)
    }

    const handleInfoFieldChange = (idx, value) => {
        let updatedFields = [...participantInfoFields];
        updatedFields[idx] = value;
        setParticipantInfoFields(updatedFields);
    }

    const handleAddInfoField = () => {
        let updatedFields = [...participantInfoFields];
        updatedFields.push('');
        setParticipantInfoFields(updatedFields);
    }
    const handleRemoveInfoField = (idx) => {
        if(participantInfoFields.length > 1) {
            let updatedFields = [...participantInfoFields];
            updatedFields.splice(idx, 1);
            setParticipantInfoFields(updatedFields);
        }
    }

    if (loading) {
        return <CustomLoader loading={loading}/>
    }

    return <>
        <div className='d-flex justify-content-between'>
            <div className="custom-control custom-switch mt-n2">
                <input
                    type="checkbox"
                    name='Include In Row'
                    id={'IncludeInRow' + Widget_ID}
                    className="custom-control-input"
                    checked={withinRow}
                    value={withinRow}
                    onChange={handleSwitch}
                />
                <label htmlFor={'IncludeInRow' + Widget_ID} className="custom-control-label">
                    Include in row widget
                </label>
            </div>
        </div>
        <div className="form-group mt-3">
            <label htmlFor={"MDHProject" + Widget_ID}>MDH Project</label>
            <Select
                isDisabled={false}
                options={MDHProjects}
                name='mdhProject'
                onChange={handleSelectMDHProject}
                placeholder='Select MDH Project...'
                value={MDHProject ? MDHProject : MDHProjects[0]}
                // defaultValue={MDHProjects[0]}
            />
        </div>
        <div className="form-group form-check">
            <label className='form-check-inline'>
                <input
                    type='radio'
                    className='form-check-input'
                    name='type'
                    value='Get Participant Info'
                    checked={type === 'Get Participant Info'}
                    onChange={handleInput}
                />
                Get Participant Info
            </label>
            <label className='form-check-inline'>
                <input
                    type='radio'
                    className='form-check-input'
                    name='type'
                    value='Update Participant Info'
                    checked={type === 'Update Participant Info'}
                    onChange={handleInput}
                />
                Update Participant Info
            </label>
            <label className='form-check-inline'>
                <input
                    type='radio'
                    className='form-check-input'
                    name='type'
                    value='Get Survey Info'
                    checked={type === 'Get Survey Info'}
                    onChange={handleInput}
                />
                Get Survey Info
            </label>
            <label className='form-check-inline'>
                <input
                    type='radio'
                    className='form-check-input'
                    name='type'
                    value='Get Survey Answer Date'
                    checked={type === 'Get Survey Answer Date'}
                    onChange={handleInput}
                />
                Get Survey Answer Date
            </label>
        </div>
        {
            (type === 'Get Participant Info' || type === 'Update Participant Info') && <div className="form-group">
                <label htmlFor={"participantInfoField" + Widget_ID}>Participant Info Field</label>

                {
                    participantInfoFields.map((field, idx) => (
                        <div>
                            <input
                                className="form-control d-inline mb-2"
                                id={"participantInfoField" + Widget_ID}
                                type="text"
                                name="participantInfoField"
                                value={field}
                                placeholder="Participant Info Field"
                                onChange={(e) => handleInfoFieldChange(idx, e.target.value)}
                                style={{width: '90%'}}
                            />
                            {participantInfoFields.length > 1 &&
                                <button className='btn bg-transparent d-inline' onClick={() => handleRemoveInfoField(idx)}>
                                    <Icon.X/>
                                </button>
                            }
                        </div>
                    ))
                }
                {type === 'Update Participant Info' &&
                    <div className='text-center mt-1'>
                        <button className='btn btn-outline-primary btn-icon btn-sm' onClick={handleAddInfoField}>
                            <Icon.Plus size={18} />
                        </button>
                    </div>
                }
            </div>
        }
        {
            (type === 'Get Survey Info' || type === 'Get Survey Answer Date') && <div>
                <div className="form-group mt-3">
                    <label htmlFor={"MDHSurvey" + Widget_ID}>MDH Survey</label>
                    <input
                        className="form-control"
                        id={"mdhSurvey" + Widget_ID}
                        type="text"
                        name="mdhSurvey"
                        value={MDHSurvey}
                        placeholder="MDH Survey Name"
                        onChange={handleInput}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor={"questionStepIdentifier" + Widget_ID}>Question Step Identifier</label>
                    <input
                        className="form-control"
                        id={"questionStepIdentifier" + Widget_ID}
                        type="text"
                        name="questionStepIdentifier"
                        value={questionStepIdentifier}
                        placeholder="Question Step Identifier"
                        onChange={handleInput}
                    />
                </div>
            </div>
        }
        <div className="form-group">
            <label htmlFor={"title" + Widget_ID}>Title</label>
            <input
                className="form-control"
                id={"title" + Widget_ID}
                type="text"
                name="title"
                value={title}
                placeholder="Title"
                onChange={handleInput}
            />
        </div>
        <div className="form-group">
            <label htmlFor={"widgetDescription" + Widget_ID}>Widget Description</label>
            <input
                className="form-control"
                id={"widgetDescription" + Widget_ID}
                type="text"
                name="widgetDescription"
                value={widgetDescription}
                placeholder="Widget Description"
                onChange={handleInput}
            />
        </div>
        {type === 'Update Participant Info' ? (
            <div className="form-group">
                <label htmlFor={"widgetUpdate" + Widget_ID}>Select Widget to Update Field With</label>
                <select
                    id={"widgetUpdate" + Widget_ID}
                    name={Widget_ID}
                    key={Widget_ID}
                    value={updateQuestionWidgetID}
                    className="form-control"
                    onChange={(e) => handleUpdateQuestionWidgetIDSelection(e.target.value)}
                >
                    <option value="0"> - Select -</option>
                    {formQAQWidgets.map((option) => (
                        <option value={option.Widget_ID}>
                            Widget
                            #{option.Widget_ID}: {option.Question_Text ? stripTags(option.Question_Text) : ''}
                        </option>
                    ))}
                </select>
            </div>
        ) : (
            <div className='form-check mt-3 mb-3'>
                <input type='checkbox' className='form-check-input' id='updateQuestion' name='updateQuestion'
                       checked={updateQuestion} onChange={handleUpdateQuestionChange}/>
                <label htmlFor='updateQuestion' className='form-check-label'>
                    Use MDH data to update and map a question's response?
                </label>
                <CustomTooltip title="Select this config to update and map a question's response" placement='right'
                               className="text-muted pl-1 d-inline">
                    <Icon.Info size={20}/>
                </CustomTooltip>

                {updateQuestion &&
                    <div>
                        <p className='mt-1 mb-0'>Please choose the question to update and map from below:</p>
                        <div className="input-group input-group-joined mr-1">
                            <select
                                name={Widget_ID}
                                key={Widget_ID}
                                value={updateQuestionWidgetID}
                                className="form-control"
                                onChange={(e) => handleUpdateQuestionWidgetIDSelection(e.target.value)}
                            >
                                <option value="0"> - Select -</option>
                                {formQAQWidgets.map((option) => (
                                    <option value={option.Widget_ID}>
                                        Widget
                                        #{option.Widget_ID}: {option.Question_Text ? stripTags(option.Question_Text) : ''}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                }
            </div>
        )}
        <div className="d-flex justify-content-end mt-2">
            <button
                className="btn btn-outline-primary mr-2"
                onClick={onSave}
            >
                Save
            </button>
            <button
                className="btn btn-outline-danger"
                onClick={() => onRemove(Widget_ID)}
            >
                Delete
            </button>
        </div>
    </>
}

export default WMDHData